var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1224",
    "data-name": "Grupo 1224",
    transform: "translate(172 7703)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_87",
    className: "circleIconState",
    "data-name": "Elipse 87",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(-172 -7703)",
    fill: "#46c17d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1223",
    "data-name": "Grupo 1223",
    transform: "translate(-598.756 -7882.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_882",
    "data-name": "Caminho 882",
    d: "M459.517,196.689H444.4a1.6,1.6,0,0,0-1.6,1.6v2.78a1.594,1.594,0,0,0,1.385,1.577v9.325h5.137v-4.827H454.6v4.827h5.137v-9.325a1.594,1.594,0,0,0,1.383-1.577v-2.78A1.6,1.6,0,0,0,459.517,196.689Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_883",
    "data-name": "Caminho 883",
    d: "M440.241,190.781a3.248,3.248,0,0,0-3.222-2.911h0a3.248,3.248,0,0,0-3.224,2.911h-.035v10.134a3.246,3.246,0,0,0,1.334,2.614l-1.32,8.441h6.492l-1.321-8.441a3.244,3.244,0,0,0,1.335-2.618v-10.13Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsina);
export default __webpack_public_path__ + "static/media/Usina.62e08d40a6bc04516063d181e525b394.svg";
export { ForwardRef as ReactComponent };